import gql from "graphql-tag";

export const USER_GOALS_QUERY = gql`
  query userGoals($userId: ID!) {
    userGoals(userId: $userId) {
      webappGoal {
        id
        primaryGoal
        secondaryGoal
        comments
      }
      ticketGoal {
        id
        weight
        runningDistanceInKm
        smartGoal
        ultimateWhy
      }
    }
  }
`;

export const ACTIVITIES_QUERY = gql`
  query goalActivities {
    goalActivities
  }
`;

export const CLIENT_GOALS_QUERY = gql`
  query clientGoals($userId: ID!, $active: Boolean) {
    clientGoals(userId: $userId, active: $active) {
      id
      ultimateWhy
      timeframe
      type
      category
      dueDate
      status
      achievedAt
      createdAt
    }
  }
`;

export const CLIENT_ONBOARDING_GOALS_QUERY = gql`
  query user($id: ID!) {
    user(id: $id) {
      id
      userProfile {
        id
        weight
        desiredWeight
        desiredWeightLoss
      }
    }
  }
`;

export const UPSERT_GOAL_MUTATION = gql`
  mutation upsertClientGoal($input: GoalInput!, $measurements: [GoalMeasurementInput]) {
    upsertClientGoal(input: $input, measurements: $measurements) {
      success
    }
  }
`;


export const DELETE_GOAL_MUTATION = gql`
  mutation deleteClientGoal($clientGoalId: ID!) {
    deleteClientGoal(clientGoalId: $clientGoalId){
      success
    }
  }
`;


